module.exports = __webpack_public_path__ + "img/logo_horizontal.048f8451.svg";